export const ROUTER_NAMES = {
  login: 'Login',
  home: 'Home',
  deviceAuth: 'DeviceAuth',
  inspection: {
    root: 'Inspection',
    basicInfo: 'BasicInfo',
    buildingInfo: 'BuildingInfo',
    step1: 'Step1',
    step2: 'Step2',
    result: 'Result'
  }
}
